import React from 'react'
import PropTypes from 'prop-types'
import Sidebar from './sidebar'

const Search = ({ value, onChange }) => {
  return <input value={ value } onChange={ (e) => onChange(e.target.value) } placeholder="Search event" className="search" />
}

export default class Header extends React.Component {

  static propTypes = {
    search: PropTypes.string,
    onSearch: PropTypes.func
  }

  state = {
    mobileOpened: false
  }

  toggleHamburger = () => {
    if (this.state.mobileOpened) {
      this.setState({ mobileOpened: false });
      return;
    }
    this.setState({ mobileOpened: true });
  }

  render() {
    return (
      <React.Fragment>
        <header className="glossary-header">
          <a href="/" className="glossary-header-title"><span className="logo" /> Glossary</a>
          <Search value={ this.props.search } onChange={ (searchString) => { this.props.onSearch(searchString) } } />
        </header>
        {/* MOBILE HEADER */}
        <header className="glossary-header mobile">
          <a href="/" className="glossary-header-title"><span className="logo" /> Glossary</a>
          <label className="menu-button">
            <div className={ `hamburger ${ this.state.mobileOpened ? 'active' : '' }` } onClick={ this.toggleHamburger }>
              <div className="stick" />
              <div className="stick" />
              <div className="stick" />
            </div>
          </label>
        </header>
        <Sidebar mobile opened={ this.state.mobileOpened } { ...this.props } />
      </React.Fragment>
    );
  }
}
